import { render, staticRenderFns } from "./fixmenu.vue?vue&type=template&id=549a0064&scoped=true"
import script from "./fixmenu.vue?vue&type=script&lang=js"
export * from "./fixmenu.vue?vue&type=script&lang=js"
import style0 from "./fixmenu.vue?vue&type=style&index=0&id=549a0064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a0064",
  null
  
)

export default component.exports